import { PlanModelInfo, planTypes } from '@/common/constants';
import { licenseDependBasePlanTypeList } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';
import { dependBasePlanTypeList } from "./utils"

const customAvatarsCategory = {
  custom_avatars: {
    typeNameKey: 'billing.custom_avatars.title',
    planNameKey: 'billing.custom_avatars.title',
  },
};



export default (planMapJSON = {}) => {
  const billingCycleDependBasePlanTypeList = dependBasePlanTypeList;
  const categoryValue = planMapJSON[planTypes.CUSTOM_AVATARS] || {};
  const result = Object.keys(customAvatarsCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.CUSTOM_AVATARS).map((item) => ({
        ...item,
        ...customAvatarsCategory[key],
        billingCycleDependBasePlanTypeList,
        dependBasePlanTypeList,
        unit: planUnitMap.user,
        min: 1,
        max: 99,
        excessPriceCents: categoryValue.excessPriceCents,
        licenseDependBasePlanTypeList,
        planModel: PlanModelInfo.license
      })),
      ...pre,
    ];
  }, []);
  return result;
};
